import { Link } from "react-router-dom";
import { imgUrl } from "./ExperienceCard";

export default function ParcoursCard({ parcours: pc, index = 0 }) {
    return (
        <Link to={`/parcours/${pc.slug}`} data-testid={`parcours-card-${pc.slug}`} className="group block">
            <div className="cp-image-zoom aspect-[16/10] bg-cp-craie mb-6">
                <img src={imgUrl(pc.image)} alt={pc.title} loading="lazy" className="w-full h-full object-cover cp-photo-warm" />
            </div>
            <div className="flex items-baseline gap-4">
                <span className="cp-serif text-2xl italic text-cp-sable-deep">{String(index + 1).padStart(2, "0")}</span>
                <div className="flex-1">
                    <p className="cp-tiny text-cp-sable-deep mb-2">{pc.theme} · {pc.duration}</p>
                    <h3 className="cp-serif text-3xl md:text-4xl leading-tight text-cp-encre group-hover:italic transition-all mb-3">
                        {pc.title}
                    </h3>
                    <p className="cp-serif italic text-lg text-cp-gris leading-snug max-w-2xl">{pc.tagline}</p>
                    {pc.stops?.length > 0 && (
                        <p className="cp-tiny text-cp-gris mt-4">
                            {pc.stops.length} étapes{pc.total_distance_km ? ` · ${pc.total_distance_km} km` : ""}
                        </p>
                    )}
                </div>
            </div>
        </Link>
    );
}
